<template>
  <div class="sideSpringFrame">
    <div class="sideSpringFrame_left">
      <div class="left_top" @click="$emit('close')">
        <i class="close">×</i>
      </div>
      <div />
    </div>
    <div class="sideSpringFrame_right">
      <header class="right_titleArea">
        <h3>{{ datas.name }}</h3>
      </header>
      <main class="right_main">
        <div v-show="show" class="main_top">
          <div class="top_main">
            <ul class="main_box">
              <li class="box_item">
                <span class="item_text">平台id</span>
                <input v-model.trim="struct.id" class="item_input">
              </li>
              <li class="box_item">
                <span class="item_text">客户编码</span>
                <input v-model.trim="struct.merchant_code" class="item_input">
              </li>
            </ul>
            <div class="main_button">
              <button class="button cancel">取消</button>
              <button class="button determine" @click="addTo">确定</button>
            </div>
          </div>
        </div>
        <div class="selectionArea">
          <div class="searchContainer">
            <label class="inputLabel">客户名称：</label>
            <el-input v-model="Query.merchant_name" placeholder="请输入内容" />
          </div>
          <el-button
            style="height: 37px"
            type="primary"
            icon="el-icon-search"
            @click="handleSearch"
          >搜索</el-button>
          <el-button
            style="height: 37px"
            type="primary"
            icon="el-icon-refresh-left"
            @click="reset"
          >重置</el-button>
        </div>
        <div class="main_bottom">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%; height: 100%"
            max-height="500"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column prop="id" label="id" width="50" />
            <el-table-column prop="merchant_name" label="客户名称" />
            <el-table-column prop="merchant_id" label="客户id" />

            <el-table-column prop="merchant_code" label="客户编码" />
            <el-table-column prop="created_at" label="创建时间" />
            <el-table-column :key="mathRandom" label="操作" align="center">
              <template slot-scope="scope">
                <span>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="modifyAccount(scope.row)"
                  >
                    平台设置客户档案
                  </el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- <Pagination :total="20" @pagination="redundancy" /> -->
          <pagination-right
            :total="total"
            @size-change="fetchPageSize"
            @current-change="fetchCurrentPage"
          />
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  merchant_list,
  set_yonyou_merchant,
  disableEnable,
  deletePlatformAccount,
  modifyData,
  deleteproform
} from '@/api/providerAccountManagement/servicePorviderList.js'
// import Pagination from '@/components/Pagination/index.vue'

export default {
  components: {
    // Pagination,
    PaginationRight
  },
  props: {
    datas: {
      type: Object,
      default: null
    },
    close: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      modifyDataQuery: {},
      tableData: [],
      struct: {},
      loading: false,
      mathRandom: null,
      actionId: null,
      textName: '',
      ids: [],
      Query: {
        merchant_id: null,
        merchant_code: null,
        merchant_name: null,
        page: 1,
        page_size: 10
      },
      total: 0,
      show: false
    }
  },
  mounted() {
    window.aa = this
    this.redundancy()
  },
  methods: {
    handleSearch() {
      this.Query.page = 1
      this.Query.page_size = 10
      this.redundancy()
    },
    reset() {
      this.Query = {
        merchant_id: null,
        merchant_code: null,
        merchant_name: null,
        page: 1,
        page_size: 10
      }
      this.redundancy()
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.Query.page_size = data
      this.redundancy()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.Query.page = data
      this.redundancy()
    },
    async myJudge(index, tableData) {
      const id = tableData[index].id
      const status = tableData[index].status
      this.loading = true
      await disableEnable(id, status === 1 ? 0 : 1)
      await this.redundancy()
      this.$message({
        message: status ? '禁用成功' : '启用成功',
        type: 'success'
      })
    },
    async addTo() {
      const rule = this.ruleLimit(this.struct)
      if (!rule) {
        this.$message({
          message: '任一输入项都不能为空',
          type: 'error'
        })
        return
      }
      this.loading = true
      await set_yonyou_merchant(this.struct)
      await this.redundancy()
      this.show = false
      this.$message({
        message: '设置成功',
        type: 'success'
      })
    },
    async deleteAccount(index, tableData) {
      await deletePlatformAccount(this.tableData[index].id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.actionId = null
      this.textName = ''
      await this.redundancy()
    },
    // 修改表格数据请求
    modifyTableData(id, data, account_name) {
      modifyData(id, data, account_name).then((res) => {
        this.redundancy()
      })
    },
    // 显示表格修改输入框
    async modifyAccount(data) {
      // this.show = true
      this.struct.id = this.datas.id
      this.struct.merchant_code = data.merchant_code
      // this.$forceUpdate()
      this.loading = true
      await set_yonyou_merchant(this.struct)
      // await this.redundancy()
      this.$message({
        message: '平台设置用友客户档案上传成功',
        type: 'success'
      })
      this.loading = false
      this.close()
    },
    // 判断请求参数是否为空的方法
    ruleLimit(data) {
      for (const item in data) {
        if (data[item] === null || data[item] === '') {
          return false
        }
      }
      return true
    },
    // 修改表格数据的确定按钮
    confirmAccount(data) {
      // 函数执行得到返回值
      const flagValue = this.ruleLimit(this.modifyDataQuery)
      if (!flagValue) {
        this.$message({
          message: '任一输入项都不能为空',
          type: 'error'
        })
      } else {
        this.modifyTableData(data.id, this.modifyDataQuery, this.textName)
        this.actionId = null
        this.textName = ''
      }
    },
    // 取消修改
    cancelAccount(index) {
      this.tableData[index].show = false
      this.actionId = null
      this.textName = ''
      this.mathRandom = Math.random()
    },
    open(data) {
      this.columnId = data.id
      this.redundancy()
    },
    async redundancy() {
      this.loading = true
      const data = await merchant_list(this.Query)
      this.loading = false
      this.tableData = data.data.data.list
      this.total = data.data.data.total
      // for (let i = 0; i < this.tableData.length; i++) {
      //   this.tableData[i].show = false
      // }
    },
    handleSelectionChange(val) {
      this.ids = []
      val.forEach((item) => {
        this.ids.push(item.id)
      })
      console.log('val', val, this.ids)
    },
    deleteall() {
      if (this.ids.length === 0) {
        this.$message.error('请选择要删除的数据')
        return
      }
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteproform({ ids: this.ids }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.redundancy()
        })
      })
    }
  }
}
</script>
<style scoped lang="less">
.sideSpringFrame {
  min-width: 1000px;
  max-width: 1000px;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  background-color: #fafafa;
  -webkit-box-shadow: -4px 0 36px 0 rgb(0 0 0 / 8%),
    -1px 0 8px 0 rgb(0 0 0 / 6%), -1px 0 4px 0 rgb(0 0 0 / 2%);
  box-shadow: -4px 0 36px 0 rgb(0 0 0 / 8%), -1px 0 8px 0 rgb(0 0 0 / 6%),
    -1px 0 4px 0 rgb(0 0 0 / 2%);
  display: flex;
  z-index: 1111;
  position: fixed;
  top: 0px;
  right: 0px;
  .sideSpringFrame_left {
    width: 48px;
    height: 100%;
    background: #fff;
    -webkit-box-shadow: 1px 0 0 0 rgb(0 0 0 / 6%);
    box-shadow: 1px 0 0 0 rgb(0 0 0 / 6%);
    z-index: 2;
    .left_top {
      width: 48px;
      height: 48px;
      background: #fff;
      -webkit-box-shadow: 0 1px 0 0 hsl(0deg 0% 87% / 50%);
      box-shadow: 0 1px 0 0 hsl(0deg 0% 87% / 50%);
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      -webkit-box-align: center;
      align-items: center;
      -ms-flex-pack: center;
      -webkit-box-pack: center;
      justify-content: center;
      cursor: pointer;
      font-size: 19px;
      .close {
        font-style: normal;
        font-size: 30px;
      }
    }
  }

  .sideSpringFrame_right {
    width: 100%;
    .right_titleArea {
      width: 100%;
      height: 49px;
      background: #fff;
      border-bottom: 1px solid #ececec;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding-left: 20px;
    }

    .right_main {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 49px;
      // height: calc(100% - 49px);
      flex-direction: column;
      justify-content: space-evenly;
      .main_top {
        width: 90%;
        border: 1px solid #ccc;
        background-color: #fff;
        margin: 0 auto;

        .top_main {
          padding: 10px;
          .main_box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .box_item {
              margin: 10px 0px;
              .item_text {
                width: 100px;
                display: inline-block;
              }
              .item_input {
                width: 150px;
                height: 27px;
                outline: none;
                padding-left: 10px;
                border: 1px solid #ccc;
                &:focus {
                  border-color: #008c8c;
                }
              }
            }
          }

          .main_button {
            margin-top: 10px;
            text-align: center;
            .button {
              outline: none;
              padding: 5px 10px;
              margin: 0px 10px;
              cursor: pointer;
              &.cancel {
                border: 1px solid #ccc;
                background-color: #fff;
                &:hover {
                  background-color: #f3f0f0;
                }
              }

              &.determine {
                font-weight: 500;
                color: #fff;
                background-color: #07c160;
                -webkit-box-shadow: 0 0 0 1px rgb(0 0 0 / 15%),
                  0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 0 1px #07c160;
                box-shadow: 0 0 0 1px rgb(0 0 0 / 15%),
                  0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 0 1px #07c160;
                border: none;
                &:hover {
                  background-color: #07a754;
                }
              }
            }
          }
        }
      }

      .main_bottom {
        margin-top: 20px;
        width: 90%;
        height: 500px;
        border: 1px solid #ccc;
        background-color: #fff;
        /deep/ .pagination-container {
          background: #fafafa;
          margin-top: 0px;
        }
      }
    }
  }
}
.selectionArea {
  display: flex;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 120px;
  }
}
</style>
